import { render, staticRenderFns } from "./View-departamento.vue?vue&type=template&id=f1a1c80a&"
import script from "./View-departamento.vue?vue&type=script&lang=js&"
export * from "./View-departamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports